import RandingStyle17 from "../../randing/RandingStyle17";
// import { Helmet } from "react-helmet";

function Randing094({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle17
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/094/250211_01.jpg`}
      video1Thumbnail={`${process.env.REACT_APP_CDN_BASE}/images/094/250211_02.jpg`}
      video1Path={`${process.env.REACT_APP_CDN_BASE}/images/094/250211_03.mp4`}
      // video2Thumbnail={`${process.env.REACT_APP_CDN_BASE}/images/094/250117_02.jpg`}
      video2Path={`${process.env.REACT_APP_CDN_BASE}/images/094/250211_05.mp4`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/094/250211_04.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/077/250117_04-2.jpg`}
      formFieldColor="white"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/benefitArrowButton.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing094;
